import styled, { keyframes } from 'styled-components';

export const WebcamDraggable = styled.div`
  height: 150px;
  width: 200px;
  background-color: #222222;
  cursor: move;
  overflow: hidden;
  position: absolute;
  // border-radius: 50%;
  z-index: 1033;
`;

export const blink = keyframes`
  0%, 100% { opacity: 0; }
  50% { opacity: 1; }
`;

export const BlinkingDot = styled.span`
  animation-name: ${blink};
  animation-duration: 1s;
  animation-iteration-count: infinite;
  color: red;
  width: 10px;
  height: 10px;
  position: inherit;
  margin-left: 8px;
  margin-right: 8px;
  border-radius: 50px;
`;

export const WebcamPreviewControllers = styled.div`
  padding: 4px;
  position: inherit;
  height: 150px;
  width: 200px;
  z-index: 1;
  // right: 10px;
  color: white;

  .webcam-preview-icon {
    color: white;
  }

  .minimize-webcam-preview {
    height: 35px !important;
  }
`;

export const PreventCopyPastInput = styled.input`
  width: 0.1px;
  height: 0.1px;
  overflow: hidden;
  display: none;
`;

export const WebcamNotDetected = styled.img`
  width: 64px;
  height: 64px;
`;

export const WebcamNotDetectedMoreItems = styled.div`
  background-color: #f4f4f4;
  padding: 16px;
  border-radius: 5px;
`;

export const ToggleMore = styled.span`
  font-weight: 500;
`;

export const Bolder = styled.span`
  font-weight: 600;
`;

export const WebcamNotDetectedIcon = styled.img`
  width: 32px;
  height: 32px;
`;
